import { render, staticRenderFns } from "./AppointmentsSelectedCase.vue?vue&type=template&id=c6336e80&"
import script from "./AppointmentsSelectedCase.vue?vue&type=script&lang=js&"
export * from "./AppointmentsSelectedCase.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentsSelectedCase.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AppointmentsSelectedCase.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VChip,VSimpleTable,VSkeletonLoader})
